<div class="pagination-wrapper">
  <!-- Page Size Dropdown -->
  <div class="pagination-controls">
    <label for="pageSize" class="page-size-label">Items per page:</label>
    <select
      id="pageSize"
      [ngModel]="pageSize"
      (ngModelChange)="onPageSizeChange($event)"
      class="page-size-select"
    >
      <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
    </select>
  </div>
 
  <!-- Pagination Buttons -->
  <div class="pagination-buttons">
    <button
      type="button"
      [disabled]="page === 1"
      (click)="goToPage(page - 1)"
      class="pagination-btn pagination-nav"
      [class.disabled]="page === 1"
      title="Previous page"
    >
      Prev
    </button>
    
    <ng-container *ngFor="let p of displayPages()">
      <button
        *ngIf="!isEllipsis(p)"
        type="button"
        (click)="goToPage(+p)"
        [class.active]="p === page"
        class="pagination-btn pagination-page"
        [title]="'Go to page ' + p"
      >
        {{ p }}
      </button>
      <span *ngIf="isEllipsis(p)" class="pagination-ellipsis">...</span>
    </ng-container>
    
    <button
      type="button"
      [disabled]="page === totalPages"
      (click)="goToPage(page + 1)"
      class="pagination-btn pagination-nav"
      [class.disabled]="page === totalPages"
      title="Next page"
    >
      Next
    </button>
  </div>
</div>
